import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header align-items-center bg-success border-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-light h3" }, "Pending Trainee")
  ])
], -1)
const _hoisted_3 = { class: "card-body pt-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "mb-5 mt-3" }, "Pending Trainee List")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-end col",
    "data-kt-industry-table-toolbar": "base"
  })
], -1)
const _hoisted_5 = { class: "card mb-5 mb-xl-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainer_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px form-control-sm",
          placeholder: "Search"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "col-md-6 mt-1 text-end",
      "data-v-54b12dc8": ""
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-dark fs-7 p-2 rounded-0",
        title: "Download Xlse",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-excel fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" Excel ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-warning fs-7 p-2 rounded-0",
        title: "Download PDF",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-pdf fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" PDF ")
      ]),
      /*#__PURE__*/_createElementVNode("button", {
        type: "button",
        class: "btn btn-primary fs-7 p-2 rounded-0",
        title: "Download CSV",
        "data-v-54b12dc8": ""
      }, [
        /*#__PURE__*/_createElementVNode("i", {
          class: "fas fa-file-csv fs-5",
          "data-v-54b12dc8": ""
        }),
        /*#__PURE__*/_createTextVNode(" CSV ")
      ])
    ])
  ])
], -1)
const _hoisted_7 = {
  id: "trainer_data",
  class: "collapse show"
}
const _hoisted_8 = { class: "collapse show" }
const _hoisted_9 = { class: "card-body border-top p-6" }
const _hoisted_10 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_11 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer" }
const _hoisted_14 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }
const _hoisted_15 = { class: "fs-7 border-0" }
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-light" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EntityModal = _resolveComponent("EntityModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("table", _hoisted_13, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeader, (header) => {
                              return (_openBlock(), _createElementBlock("th", {
                                key: header.key,
                                scope: "col"
                              }, _toDisplayString(header.name), 1))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tbody", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.traineeInfos, (info) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: info.id,
                              style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51)"}
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_component_router_link, {
                                    title: "View",
                                    class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                    to: {
                                  name: 'Trainee Details',
                                  params: { id: info.id },
                                }
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_17
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.Approve(info.id)),
                                    class: "btn btn-icon btn-bg-success btn-active-color-primary btn-sm mr-2",
                                    title: "Approve"
                                  }, _hoisted_20, 8, _hoisted_18),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.Reject(info.id)),
                                    class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm",
                                    title: "Reject"
                                  }, _hoisted_23, 8, _hoisted_21)
                                ])
                              ]),
                              _hoisted_24,
                              _createElementVNode("td", null, _toDisplayString(info.name), 1),
                              _createElementVNode("td", null, _toDisplayString(info.training_institute), 1),
                              _createElementVNode("td", null, _toDisplayString(info.course), 1),
                              _createElementVNode("td", null, _toDisplayString(info.ref_no), 1),
                              _createElementVNode("td", null, _toDisplayString(info.email), 1),
                              _createElementVNode("td", null, _toDisplayString(info.mobile), 1),
                              _createElementVNode("td", null, _toDisplayString(info.present_address), 1),
                              _createElementVNode("td", null, _toDisplayString(info.date_of_birth), 1),
                              _createElementVNode("td", null, _toDisplayString(info.gander), 1),
                              _createElementVNode("td", null, _toDisplayString(info.status == 1 ? "Active" : "Inactive"), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_EntityModal)
  ], 64))
}